import { Injectable, Injector } from '@angular/core';
import { PlatformApiWpService } from './platform-apiwp.service';
import { BehaviorSubject, catchError, lastValueFrom, Observable, Subject } from 'rxjs';
import { PlatformApiWPublicService } from './platform-apiwp-public.service';
import { MareAuthService } from '@mare-common/ngx-mare-auth';
import { TokenService } from './token.service';
import { HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { ErrorHandlerService } from '@mare-common/ngx-mare-common';
import { DoubleService } from './double-service';

@Injectable({
  providedIn: 'root'
})
export class LandingService extends DoubleService {
  isInit: boolean = false;
  isInit$ = new Subject<boolean>();
  dashboardData!: any;
  bollettaData!: any;

  // #platformApiWpService: inject(PlatformApiWpService);

  /**
   * platformApiWpService viene inizializzato con PlatformApiWPublicService se non sono loggati
   * altrimenti viene inizializzato con PlatformApiWpService
   * PlatformApiWPublicService si occupa di prendere il token dalla query string e inserirlo in query string su tutte le GET
   */
  // private platformApiWpService!: PlatformApiWPublicService | PlatformApiWpService;
  constructor(
    protected override authService: MareAuthService,
    protected override tokenService: TokenService,
    private errorHandlerService: ErrorHandlerService,
    protected override injector: Injector

  ) {
    super(authService, tokenService, injector );
    this.authService.isLogged();
    if (this.tokenService.isInit) {
      this.init();
    } else {
      let subscription = this.tokenService.isInit$.subscribe((res) => {
        if (res) {
          subscription.unsubscribe();
          this.init();
        }
      })
    }
  }

  init() {
    // if (this.authService.isLogged()) {
    //   this.platformApiWpService = this.injector.get(PlatformApiWpService);
    // } else {
    //   this.platformApiWpService = this.injector.get(PlatformApiWPublicService);
    // }
    this.isInit = true;
    this.isInit$.next(true);
  }

  verifyToken(token: string): Promise<string> {
    return new Promise(async (resolve, reject) => {

      if (!this.isInit) {
        await lastValueFrom(this.isInit$);
      }

      if (!token || token == '') {
        reject('token not found');
        return
      }
      // this.platformApiWpService.getRequest('/msc/v1/verfytoken?token='+token).then((sub: any) => {
      this.platformApiWpService.getRequest('/msc/v1/verfytoken').then((sub: any) => {
        sub.subscribe((res: any) => {
          console.log(res);
          if (res && res.status == 'ok')
            // console.log(res.payload);
            resolve(res.payload);
        })

      }, (err: any) => {
        reject(err)
      })
    })
  }

  // activateUser(): Promise<any> {
  //   return new Promise(async (resolve, reject) => {
  //     if (!this.isInit) {
  //       await lastValueFrom(this.isInit$);
  //     }
  //     // this.platformApiWpService.getRequest('/msc/v1/company/activate?token='+token).then((sub: any) => {
  //     this.platformApiWpService.getRequest('/msc/v1/company/activate').then((sub: any) => {
  //       sub.subscribe((res: any) => {
  //         console.log(res);
  //         if (res && res.status == 'ok') {
  //           resolve(res.payload);
  //         } else {
  //           reject(false);
  //         }
  //         // console.log(res.payload);
  //       })

  //     }, (err: any) => {
  //       reject(err)
  //     })
  //   })
  // }

  getLanding(token: string, force?: boolean): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if (!this.isInit) {
        await lastValueFrom(this.isInit$);
      }
      // /msc/v1/verfytoken?token='+token per verificare e risponde ok nok
      if (!token || token == '') {
        reject('token not found');
        return
      }
      if(this.bollettaData && !force) {
        resolve(this.bollettaData);
        return
      }
      // this.platformApiWpService.getRequest('msc/v1/bolletta?token='+token).then((sub: any) => {
      this.platformApiWpService.getRequest('msc/v1/bolletta').then((sub: any) => {
        sub.subscribe((res: any) => {
          console.log(res);
          if (res && res.status == 'ok') {
            this.bollettaData = res.payload;
            resolve(res.payload);
          } else {
            this.bollettaData = null;
            reject(res);
          }
        })

      }, (err: any) => {
        reject(err)
      })
    })

  }

  getBollettaFull(token: string): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if (!this.isInit) {
        await lastValueFrom(this.isInit$);
      }
      // /msc/v1/verfytoken?token='+token per verificare e risponde ok nok
      if (!token || token == '') {
        reject('token not found');
        return
      }
      this.platformApiWpService.getRequest('msc/v1/bollettaFull').then((sub: any) => {
        sub.subscribe((res: any) => {
          console.log(res);
          if (res && res.status == 'ok') {
            resolve(res.payload);
          } else {
            reject(res);
          }
        })

      }, (err: any) => {
        reject(err)
      })
    })

  }
getDashboard(force?: boolean): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if (!this.isInit) {
        await lastValueFrom(this.isInit$);
      }
      if(this.dashboardData && !force) {
        resolve(this.dashboardData);
        return
      }
      // /msc/v1/verfytoken?token='+token per verificare e risponde ok nok
      this.platformApiWpService.getRequest('msc/v1/dashboard').then((sub: any) => {
        sub.subscribe((res: any) => {
          console.log(res);
          if (res && res.status == 'ok') {
            this.dashboardData = res.payload
            resolve(res.payload);
          } else {
            this.dashboardData = null
            reject(res);
          }
        })

      }, (err: any) => {
        reject(err)
      })
    })

  }

  downloadState$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  /**
   * Downloads a report as a PDF file or in new browser tab.
   *
   * @param {string} piva - The PIVA code used to filter the report. Optional.
   * @param {'all' | 'light'} reportType - The type of report to download. Optional.
   * @param {boolean} forcedownload - Whether to force the download of the file: if false, the browser will open a new tab. Optional.
   * @return {Promise<boolean>} A promise that resolves to true if the download is successful.
   */
  downloadReport(piva?: string, reportType?: 'all' | 'light', forcedownload?: boolean): Promise<boolean | any> {
    return new Promise((resolve, reject) => {

      this.downloadState$.next({ status: 'requested' });
      let url = this.platformApiWpService.getBaseUrl() + '/msc/v1/report/download';
      let params: any = {

      }
      if (piva) {
        // url += '?piva=' + piva;
        params['piva'] = piva;
      }
      if(reportType){
        params['reportType'] = reportType;
      }

      if (this.platformApiWpService instanceof PlatformApiWPublicService) {
        params['token'] = this.platformApiWpService.getToken();
      }




      this.platformApiWpService.setHeaders().then((headers: HttpHeaders) => {
        const options: {
          headers?: HttpHeaders | {
            [header: string]: string | string[];
          };
          context?: HttpContext;
          observe?: 'body' | 'events' | 'response';
          params?: HttpParams | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
          };
          reportProgress?: boolean;
          responseType?: 'json' | 'arraybuffer' | 'blob' | 'text';
          withCredentials?: boolean;
        } = {
          headers: headers,
          responseType: 'blob',
          params: params
        }
        this.platformApiWpService.getRawRequest(url, options, false, true).pipe(
          catchError((err: any) => {
            reject(err);
            this.errorHandlerService.handleError(err);
            return err;
          })
        ).subscribe((response: any) => {

          if (response.type == 'application/pdf') {
            const blob = new Blob([response], { type: 'application/pdf' });

            const url = window.URL.createObjectURL(blob);
            this.downloadState$.next({});
            this.downloadState$.complete();


            if (forcedownload) {
              // download a file as pdf
              const a = document.createElement('a');
              document.body.appendChild(a);
              a.href = url;
              let typePrefix = reportType == 'light' ? 'light' : '';
              a.download = 'benchmark_'+typePrefix+'_di_pIVA_' + piva + '.pdf';
              a.click();
              window.URL.revokeObjectURL(url);
              a.remove();
            } else {
              // open in new tab
              window.open(url, '_blank');
            }
            resolve(true);
          } else if(response.type == 'application/json'){
            const blob = new Blob([response], { type: 'application/json' });
            const reader = new FileReader();
            reader.onload = () => {
              const content = JSON.parse(reader.result as string);
              console.log(content);
              resolve(content);
            }
            reader.readAsText(blob);
            // const content = JSON.parse(response.body.text());
            // console.log(content);
            // resolve(content);
          } else {
            reject(response);
          }
        })
      })

    })
  }

}
